<app-top-bar title="PAYMENT.PAY_CARD" [customBack]="cancel"></app-top-bar>

<div class="content">
  @if (loading) {
    <div class="loader-container">
      <mat-spinner class="loader"></mat-spinner>
      <p>{{ 'PAYMENT.PROGRESS' | translate }}</p>
    </div>
  }

  <div [id]="dropinContainerId" class="dropin-container" [class.hidden]="loading"></div>
</div>
